// extracted by mini-css-extract-plugin
export default {"booleanButton":"Phonenumbers_booleanButton__Whw8T"};